import AuthenticationCodeConfirmation from '../components/AuthenticationCodeConfirmation'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  receiveAuthCode,
  resendSMS
} from '../modules/authenticationCodeConfirmation'

const mapStateToProps = state => ({
  phoneNumber: state.authenticationCodeConfirmation.phoneNumber,
  errors: state.authenticationCodeConfirmation.errors,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  receiveAuthCode,
  resendSMS,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticationCodeConfirmation)



// WEBPACK FOOTER //
// ./src/routes/authenticationCodeConfirmation/containers/AuthenticationCodeConfirmationContainer.js